/**
 * Created by hj on 2017/8/24.
 */
import React from 'react';
import { Button } from 'antd';
import { hashHistory } from 'react-router';
import { DmsTab, TableView, FilterBox } from 'Components';
import { openNotice } from 'Utils';

class StoreList extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      opts: ['优惠券'],
      showHideBtnIndex: 0,
      key: 0,
      filterBoxVisible: false,
      rows: [
        {
          id: 1,
          name: '家装节部分商品满1000-100',
          effectStartDate: '2017-08-23',
          effectEndDate: '2017-08-24',
          issue: 20,
          received: 10,
          use: 8
        },
        {
          id: 2,
          name: '家装节部分商品满五件打9折',
          effectStartDate: '2017-08-22',
          effectEndDate: '2017-08-24',
          issue: 30,
          received: 25,
          use: 15
        }
      ],
      total: 1,
      searchObj: {
        q: '',
        effectStartDate: '',
        effectEndDate: '',
        status: '',
        pageSize: 10,
        pageNo: 1
      }
    };
    this.pageChange = this.pageChange.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
  }

  changeHandle ({ item, key, keyPath }) {
    this.setState({ key });
  }

  visibleChange () {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset () {
    /* 重置 */
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        q: '',
        effectStartDate: '',
        effectEndDate: '',
        status: '',
        pageSize: 10,
        pageNo: 1
      }
    });
    openNotice('success', '操作成功', '');
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  };

  advanceSubmit (form) {
    openNotice('success', '操作成功', '');
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  };

  setFilterParam (name, value) {
    if (name === 'effectDate') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          effectStartDate: value.from,
          effectEndDate: value.end
        }
      })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    this.setState({ searchObj: { ...this.state.searchObj, pageSize, pageNo: page } })
  }

  goView (url) {
    hashHistory.push(url);
  }

  toEdit ( index ) {
    /* 编辑 */
    this.goView('card/add/' + this.state.rows[index].id);
  }

  showHideBtn (index) {
    this.setState({
      showHideBtnIndex: index
    });
  }

  hideBtn () {
    this.setState({
      showHideBtnIndex: ''
    });
  }

  render () {
    const { opts, key, filterBoxVisible, rows, total, searchObj, showHideBtnIndex } = this.state;
    var self = this;
    const filterBoxProps = {
      showFlag: filterBoxVisible,
      advance: {
        fileds: [
          {
            name: 'q',
            label: '关键字',
            text: '请输入关键字',
            type: 'default'
          },
          {
            name: 'effectDate',//effectStartDate, effectEndDate
            label: '优惠活动时间',
            options: [
              { text: '开始时间' },
              { text: '结束时间' },
            ],
            type: 'dateComp'
          },
          {
            name: 'status',
            label: '状态',
            text: '请选择状态',
            options: [
              { value: '', text: '全部' },
              { value: '1', text: '生效中' },
              { value: '2', text: '已失效' },
            ],
            multiple: false,//支持多选
            type: 'select'
          }
        ],
        handle: this.advanceSubmit,
        reset: this.advanceReset,
        fieldHandle: this.setFilterParam
      }
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.pageNo,//当前页码
        pageSize: searchObj.pageSize,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '优惠券名称',
          dataIndex: 'name'
        }, {
          title: '生效日期',
          dataIndex: 'effectStartDate'
        }, {
          title: '失效日期',
          dataIndex: 'effectEndDate'
        }, {
          title: '发行量',
          dataIndex: 'issue',
          render: (text, record, index) => (
            <div className="bu_s_h">
              <div onMouseOver={self.showHideBtn.bind(self, index)} onMouseOut={self.hideBtn.bind(self)} className="event"></div>
              <span>{text}</span>
            </div>
          )
        }, {
          title: '已领取',
          dataIndex: 'received',
          render: (text, record, index) => (
            <div className="bu_s_h">
              <div onMouseOver={self.showHideBtn.bind(self, index)} onMouseOut={self.hideBtn.bind(self)} className="event"></div>
              <span>{text}</span>
            </div>
          )
        }, {
          title: '已使用',
          dataIndex: 'use',
          render: (text, record, index) => (
            <div className="bu_s_h">
              <div onMouseOver={self.showHideBtn.bind(self, index)} onMouseOut={self.hideBtn.bind(self)} className="event">
                <Button style={{display: showHideBtnIndex === index ? 'inline-block' : 'none'}} size={'small'} type="primary" onClick={self.toEdit.bind(self, index)}>编辑</Button>
              </div>
              <span className="btn">{text}</span>
            </div>
          )
        }
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}>
        <Button icon="plus" onClick={this.goView.bind(this, `/card/add/0`)}>新增</Button>
        <Button icon="filter" onClick={this.visibleChange}>筛选</Button>
        <FilterBox  {...filterBoxProps}/>
      </DmsTab>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
    </div>
  }
}
;
export default StoreList;


// WEBPACK FOOTER //
// ./src/routes/card/list.js